define([
    'text!index2021-cooperate/component/item-design.html',
    'index2021-cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 2,
                    companyName: '',
                    contact: '',
                    tel: '',
                    email: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/item-design.js
// module id = 233
// module chunks = 0